import { render, staticRenderFns } from "./departmentSelect.vue?vue&type=template&id=3f9da6a7&scoped=true&"
import script from "./departmentSelect.vue?vue&type=script&lang=js&"
export * from "./departmentSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9da6a7",
  null
  
)

export default component.exports